import React from 'react'
import './Resume.styles.scss'

export const Resume = () => {
  return (
    <div className='resumeContainer'>
      <div className='resumeHeader'>The official version of my journey—my resume.</div>
      <iframe src="https://pdflink.to/219c5d3c/embed/" 
        frameBorder="0" 
        title="resume.pdf"
        style={{border: 'none', height: '100vh', width: '100%', maxWidth: '100%'}}
      ></iframe>
    </div>
  )
}

export default Resume